import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Exam season eats time like women, internet and television combined",
  "description": "",
  "published": "2010-02-15T00:00:00.000Z",
  "redirect_from": ["/blog/exam-season-eats-time-like-women-internet-and-television-combined/swizec/1173"],
  "categories": "food for thought, life, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://commons.wikipedia.org/wiki/Image:Bruce_Crandall%27s_UH-1D.jpg"
          }}><img parentName="a" {...{
              "src": "https://swizec.com/blog/wp-content/uploads/2010/02/300px-Bruce_Crandall%27s_UH-1D.jpg",
              "alt": "Major Crandall's UH-1D helicopter climbs skywa...",
              "title": "Major Crandall's UH-1D helicopter climbs skywa..."
            }}></img></a></p>
        <p parentName="li">{`Image via `}<a parentName="p" {...{
            "href": "http://commons.wikipedia.org/wiki/Image:Bruce_Crandall%27s_UH-1D.jpg"
          }}>{`Wikipedia`}</a></p>
      </li>
    </ul>
    <p>{`Ah, finally, we can breathe again!`}</p>
    <p>{`The last couple of weeks ... was it two, was it three? Can't really tell, feels like I've left the office just yesterday while at the same time seeming like it's been years since I last set foot in the office to do any real work.`}</p>
    <p>{`This my friends, this ejection from the stream of time, this rejection from life, this abortion from the normality of our daily lives, this horrible feeling of floating in time like naught is happening but what you can see on your immediate palm ...`}</p>
    <p>{`... this is what exam season does to you.`}</p>
    <p>{`For me it is, luckily, already over. Some of my best buddies have another week of wartime ahead of them. Waring with evil warlords, waging battle with delusional teaching assistants. To them I wish good luck! Good luck I say!`}</p>
    <p>{`To the rest of us I say, Gidday mate! Finally, finally we have come out of that Vietnam that is the few weeks of exams. Those stressful days when your future hangs precariously at a balance and your parents are wagging their eternal finger into your face "`}<em parentName="p">{`you better pass those exams mister lest we reject you from the family unit and make you get a `}<strong parentName="em">{`real`}</strong>{` job"`}</em></p>
    <p>{`But alas dear mother! Alas I say! Alas! For I have passed three out of five exams and that means I've got a 60% success rate and not even all of those were a weak mere pass! Nay! For I am victorious! Victoriously have I come out of that hell that is pure suffering.`}</p>
    <p>{`Could've done better though. Crap.`}</p>
    <p>{`PS: said season also fucks with your mind.`}</p>
    <p><a parentName="p" {...{
        "href": "http://reblog.zemanta.com/zemified/1946f9e8-e928-4897-9e43-643d1418f4a7/",
        "title": "Reblog this post [with Zemanta]"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/reblog_e.png?x-id=1946f9e8-e928-4897-9e43-643d1418f4a7",
          "alt": "Reblog this post [with Zemanta]"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      